// extracted by mini-css-extract-plugin
module.exports = {"section":"homepage-latest-mixes_section_137Pl"};